var _path, _path2, _path3, _path4, _mask, _path5, _path6, _path7, _path8, _mask2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlbumWithPhotos = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 318 211"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#737373",
  strokeWidth: 2,
  d: "M316.797 1H182.06a23.03 23.03 0 0 0-16.305 6.77A23.14 23.14 0 0 0 159 24.113V210h134.94c6.115 0 11.98-2.435 16.305-6.769A23.14 23.14 0 0 0 317 186.886V1.206a.2.2 0 0 0-.06-.147.2.2 0 0 0-.143-.059Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeWidth: 2,
  d: "M160 209c0-7.667 5.7-23 28.5-23H318"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#737373",
  strokeWidth: 2,
  d: "M1.203 1H135.94c6.115 0 11.98 2.435 16.305 6.77A23.14 23.14 0 0 1 159 24.113V210H24.06a23.04 23.04 0 0 1-16.305-6.769A23.14 23.14 0 0 1 1 186.886V1.206a.2.2 0 0 1 .06-.147A.2.2 0 0 1 1.203 1Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeWidth: 2,
  d: "M31 36h88v118H31zm157 18h107v75H188z"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_AlbumWithPhotos.svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m41.5 153.798.124-7.405c.124-17.402 14.483-31.595 31.938-31.595h.248c13.864.124 19.31 11.725 25.5 25.301 1.857 3.949 3.714 7.528 6.19 13.699"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#737373",
  d: "m41.624 146.393 2 .034v-.019zm32.185-31.595.018-2h-.017zm25.501 25.301-1.82.83.006.01.005.011zM43.5 153.832l.123-7.405-3.999-.067-.124 7.405zm.124-7.424c.116-16.296 13.575-29.61 29.938-29.61v-4c-18.546 0-33.806 15.073-33.938 33.581zm29.938-29.61h.248v-4h-.248zm.23 0c6.249.056 10.553 2.646 14.114 6.891 3.66 4.364 6.46 10.388 9.585 17.24l3.639-1.66c-3.066-6.724-6.083-13.289-10.16-18.15-4.176-4.98-9.527-8.253-17.143-8.321zM97.5 140.95c1.881 4.002 3.696 7.493 6.143 13.593l3.712-1.489c-2.504-6.242-4.404-9.909-6.236-13.806z",
  mask: "url(#jottacloud_AlbumWithPhotos.svg__a)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#737373",
  strokeWidth: 2,
  d: "M75.5 66.798c11.602 0 21 9.367 21 20.913v12.174c0 11.547-9.398 20.913-21 20.913s-21-9.366-21-20.913V87.711c0-11.546 9.398-20.913 21-20.913Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57 90v9c-1.167-.5-3.6-2-4-4s2.5-4.167 4-5"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M59.5 143.298v9.5m12.5-43c1.667 1.667 6.1 4.4 10.5 2m-4.5-10.5c0 1.5.8 4.2 4 3s1.667-4.166.5-5.5l-2.5-3.5m5-3.001c1.667-1.167 5.5-2.7 7.5.5m-25 .5c1.333-1.834 4.8-4.5 8-.5m-15.5-8.5h24.5v-6l4 6h4M59 89.5c-2.5-.5-5.5 1.697-5.5 5.297s3 4.703 5.5 4.703M31 65.297c2.167-1.5 6.428-4.212 9-6.498 4.5-4 8.936-6.905 14-7.5 8.5-1 13.157.273 30.5 7.5 18 7.5 22.5 7.497 34 5.498"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_AlbumWithPhotos.svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.129 75c-1.172-7.764 5.858-14.128 12.77-11.327 1.64.636 3.046 1.909 4.101 3.436"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#737373",
  d: "m70.9 63.673-.752 1.853.014.006.014.005zM60.105 74.702c-.483-3.2.725-6.064 2.709-7.836 1.97-1.76 4.659-2.423 7.334-1.34l1.501-3.707c-4.237-1.717-8.519-.6-11.5 2.064-2.967 2.651-4.688 6.851-3.999 11.415zm10.07-9.165c1.171.454 2.285 1.415 3.178 2.708l3.292-2.272c-1.216-1.762-2.914-3.347-5.023-4.165z",
  mask: "url(#jottacloud_AlbumWithPhotos.svg__b)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M118 52.798c-1.5-1-6.1-2.6-12.5-1s-15.667 5-19.5 6.5"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeWidth: 2,
  d: "M158 209c0-7.667-5.7-23-28.5-23H0"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M190 56c3.667 1 11.7 3.4 14.5 5 3.5 2 9 9.917 18.5 11.5 3 .5 10 0 14.5 1 3.477.773 10.836 6.62 17 11.085M295 107c-1.5-2.5-6.3-8-13.5-10-9-2.5-15.5-5-22-9-1.477-.91-3.187-2.102-5-3.415m0 0c4.667-1.862 15.3-5.685 20.5-6.085 6.5-.5 17.5.5 20-2m-58-11h12.5c.5-1.833.5-5.5 5-5.5 5.768 0 6 5.5 6 5.5s-.123-4 4-4c4.5 0 3 4.5 4.5 4.5h7.5"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#737373",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M238 103h-6v8h6z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeWidth: 2,
  d: "M200.5 102v7.5l6 6m0 0h8.5m-8.5 0V103m36-4.5v17H215m0-17v17"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#737373",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M244.5 98.5 241 84h-32.5l4 14.5z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#737373",
  d: "m213.5 99 .49.872 2.352-1.323-2.646-.53zm-8 4.5-.371.928.444.178.417-.234zm-7.5-3-.537-.844a1 1 0 0 0 .166 1.772zm9.567-16.859-5 13 1.866.718 5-13zm-4.263 14.34 10 2 .392-1.962-10-2zm9.706.147-8 4.5.98 1.744 8-4.5zm-7.139 4.444-7.5-3-.742 1.856 7.5 3zm-7.334-1.228 5.5-3.5-1.074-1.688-5.5 3.5z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#737373",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M224.5 80H220v10.5h4.5zM296 64a1 1 0 0 1-1.707.707l-12-12A1 1 0 0 1 283 51h12a1 1 0 0 1 1 1zm-111 54a1.002 1.002 0 0 1 1.707-.707l12 12A1 1 0 0 1 198 131h-12a1 1 0 0 1-1-1zM28 44a1 1 0 0 0 1.707.707l10-10A1 1 0 0 0 39 33H29a1 1 0 0 0-1 1zm94 0a1 1 0 0 1-1.707.707l-10-10A1 1 0 0 1 111 33h10a1 1 0 0 1 1 1zM28 146a1 1 0 0 1 1.707-.707l10 10A1 1 0 0 1 39 157H29a1 1 0 0 1-1-1zm94 0a1.002 1.002 0 0 0-1.707-.707l-10 10A1 1 0 0 0 111 157h10a1 1 0 0 0 1-1zm174-28a1.002 1.002 0 0 0-1.707-.707l-12 12A1 1 0 0 0 283 131h12a1 1 0 0 0 1-1zM185 64a1 1 0 0 0 1.707.707l12-12A1 1 0 0 0 198 51h-12a1 1 0 0 0-1 1z"
})));
export default SvgAlbumWithPhotos;